<template>
    <div class="tooltip" :class="{ 'tooltip--small': size }">
      <div class="shadowed">
        <div class="tooltip__header">
          <slot>
            <p>
              Find out more <a href="https://www.vixio.com/payments-platform">here</a> or email <a href="mailto:clientvalue@vixio.com">clientvalue@vixio.com</a> to activate this feature
            </p>
          </slot>
        </div>
        <div v-if="!size" class="tooltip__content">
          <p>You’ll need to raise your stakes to access this content.</p>
          <p>Contact your VIXIO Account Manager to upgrade.</p>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    size: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.tooltip {
  position: absolute;
  left: 0;
  bottom: 100%;
  // max-width: 46rem;
  // width: 46rem;
  z-index: 3;
  display: none;
  transition: 0.3s ease-out;
  border-radius: 0.5rem;
  border-bottom: 10px solid transparent;
  .shadowed {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.7);
    border-radius: 0.5rem;
  }
  &:after {
    content: "";
    width: 1rem;
    height: 1rem;
    background: $white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.7);
    position: absolute;
    bottom: -0.5rem;
    left: calc(50% - 0.5rem);
    transform: rotate(45deg);
    z-index: 1;
  }
  &--small {
    // max-width: 20rem;
    min-width: 40rem;
    bottom: calc(100%);
    &:after {
      background: $red;
      box-shadow: none;
    }
  }
  &__header {
    background: $red;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $white;
    font-size: 1.4rem;
    font-weight: 600;
    // padding-left: 1.2rem;
    height: 3.6rem;
    width: 50rem;
    border-radius: 0.5rem;

    a {
      color: $white;
      text-decoration: underline;
      padding-bottom: 1rem;
      size: 0.8rem;
      &:hover {
        color: $link-primary-hover;
        text-decoration: underline;
      }
    }
  }
  &__content {
    color: $text;
    padding: 1.6rem 1.2rem;
    position: relative;
    background: $white;
    z-index: 2;
    p:first-of-type {
      font-size: 1.6rem;
      line-height: 2rem;
      font-weight: 600;
    }
    p:last-of-type {
      font-size: 1.4rem;
    }
  }
}
</style>
